export type RatingType =
  | "Playday"
  | "Tournament"
  | "Segment"
  | "Segments"
  | "Track"
  | "Segment Track"
  | "Segments Track"
  | "Tournament Track";

export const RATING_HEADERS: { [key in RatingType]: string } = {
  Playday: "PDR",
  Tournament: "TR",
  Segment: "SDR",
  Segments: "SDR+",
  Track: "TrDR",
  "Segment Track": "STrDR",
  "Segments Track": "STrDR+",
  "Tournament Track": "TTrDR",
};

export const getRatingTitle = (type: RatingType) => {
  return (
    type +
    " Driver Rating - A Calculated Rating To Show Their Relative " +
    type +
    " Performance"
  );
};
